const DateFormatter = (dateTime) => {
  const dateFormats = { year: 'numeric', month: 'long', day: '2-digit' };

  const date =  dateTime.toLocaleDateString('en-GB', dateFormats);

  return date.toString();
};

export default DateFormatter;
